'use client'
import { themes } from '@/app/themes'
import { useContext } from 'react'
import { ThemeContext } from '../components/theme'

type Props = { className?: string }
const ThemeTags = ({ className = '' }: Props) => {
    const { theme: currentTheme, setTheme } = useContext(ThemeContext)
    return (
        <div className={`flex flex-wrap gap-1 ${className}`}>
            {themes.map((theme) => {
                const isActive = theme === currentTheme
                const activeClassName = isActive ? 'btn-primary' : ''
                return (
                    <div
                        onClick={() => {
                            setTheme(theme)
                        }}
                        key={theme}
                        className={`btn ${activeClassName} btn-xs`}
                        aria-label={theme}
                        data-set-theme={theme}
                    >
                        {theme}
                    </div>
                )
            })}
        </div>
    )
}
export default ThemeTags
